import { RESOURCE_PERMISSIONS } from "./resourcePermissions";
import { dashboardPath } from "../config/storefrontRouting";

interface DashboardRouteCandidate {
  path: string;
  anyOf: readonly string[];
}

export const DASHBOARD_ROUTE_CANDIDATES: readonly DashboardRouteCandidate[] = [
  {
    path: "/overview",
    anyOf: [...RESOURCE_PERMISSIONS.DASHBOARD],
  },
  {
    path: "/products/list",
    anyOf: [...RESOURCE_PERMISSIONS.PRODUCTS],
  },
  {
    path: "/orders",
    anyOf: [...RESOURCE_PERMISSIONS.ORDERS],
  },
  {
    path: "/website-users",
    anyOf: [...RESOURCE_PERMISSIONS.WEBSITE_USERS],
  },
  {
    path: "/commerce/inventory",
    anyOf: [...RESOURCE_PERMISSIONS.INVENTORY],
  },
  {
    path: "/commerce/reviews",
    anyOf: [...RESOURCE_PERMISSIONS.REVIEWS],
  },
  {
    path: "/commerce/reports",
    anyOf: [...RESOURCE_PERMISSIONS.REPORTS],
  },
  {
    path: "/commerce/settings",
    anyOf: [...RESOURCE_PERMISSIONS.COMMERCE_SETTINGS],
  },
  {
    path: "/products/categories",
    anyOf: [...RESOURCE_PERMISSIONS.CATEGORIES],
  },
  {
    path: "/users-rules/users",
    anyOf: [...RESOURCE_PERMISSIONS.USERS_ROLES],
  },
  {
    path: "/contact-inquiries",
    anyOf: [...RESOURCE_PERMISSIONS.CONTACT_INQUIRIES],
  },
  {
    path: "/website/homepage",
    anyOf: [...RESOURCE_PERMISSIONS.HOMEPAGE],
  },
  {
    path: "/commerce/promotions",
    anyOf: [...RESOURCE_PERMISSIONS.PROMOTIONS],
  },
  {
    path: "/settings/banners",
    anyOf: [...RESOURCE_PERMISSIONS.BANNERS],
  },
] as const;

export function canAccessDashboard({
  roleType,
  permissions,
}: {
  roleType?: string | null;
  permissions: readonly string[];
}): boolean {
  if (roleType === "credentialed") return true;
  if (roleType === "public") return false;
  return permissions.length > 0;
}

export function firstAccessibleDashboardPath({
  isCompanyPrincipal,
  permissions,
}: {
  isCompanyPrincipal: boolean;
  permissions: readonly string[];
}): string | null {
  if (isCompanyPrincipal) return dashboardPath("/overview");
  const available = new Set(permissions);
  const candidate = DASHBOARD_ROUTE_CANDIDATES.find((route) =>
    route.anyOf.some((permission) => available.has(permission)),
  );
  return candidate ? dashboardPath(candidate.path) : null;
}
